import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{ //登录
      path: '/login',
      name: '/login',
      component: (resolve) => require(['@/pages/login'], resolve),
      meta: {
        keepAlive: false
      }
    },
    { //首页
      path: '/home',
      name: 'home',
      component: (resolve) => require(['@/pages/home'], resolve),
      meta: {
        keepAlive: true
      }
    },
    { //项目管理
      path: '/project',
      name: 'project',
      component: (resolve) => require(['@/pages/project'], resolve),
      meta: {
        keepAlive: true
      }
    },
    { //项目管理
      path: '/test',
      name: 'test',
      component: (resolve) => require(['@/pages/test'], resolve),
      meta: {
        keepAlive: true
      }
    },
    { //用户管理
      path: '/user',
      name: 'user',
      component: (resolve) => require(['@/pages/user'], resolve),
      meta: {
        keepAlive: true
      }
    },
    { //企业管理
      path: '/student',
      name: 'student',
      component: (resolve) => require(['@/pages/student'], resolve),
      meta: {
        keepAlive: true
      }
    },
    { //系统设置
      path: '/setting',
      name: 'setting',
      component: (resolve) => require(['@/pages/setting'], resolve),
      meta: {
        keepAlive: true
      },
      children:[
        {
          path: 'set',
          name: 'setting',
          childrenName:'set',
          meta: {
            keepAlive: true
          },
          component: (resolve) => require(['@/pages/set'], resolve)
        },
        {
          path: 'class',
          name: 'setting',
          childrenName:'class',
          meta: {
            keepAlive: true
          },
          component: (resolve) => require(['@/pages/class'], resolve)
        },
        {
          path: 'grade',
          name: 'setting',
          childrenName:'grade',
          meta: {
            keepAlive: true
          },
          component: (resolve) => require(['@/pages/grade'], resolve)
        },
        {
          path: 'manager',
          name: 'setting',
          childrenName:'scale',
          meta: {
            keepAlive: true
          },
          component: (resolve) => require(['@/pages/manager'], resolve)
        }
      ]
    },
    {
      path: '*',
      redirect: '/login'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js